import { Paper } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../App/Components/PageContainer/PageContainer";
import { useNotification } from "../App/State/Hooks/notificationHooks";
import { useAppSelector } from "../App/State/Hooks/reduxHooks";
import { useClientChangeCallback } from "../App/State/Hooks/useClientChangeCallback";
import { selectClientValue } from "../App/State/Slices/SelectedClientSlice";
import { RenderDialog } from "../ManageCampaigns/Components/Dialog/Dialog";
import CampaignHeader from "./Components/CampaignHeader";
import FormProfileLoading from "./FormProfileLoading";
import FormTableTabs from "./FormTableTabs";
import useFormProfileState from "./State/CampaignProfileState";
import { CampaignProfileReportContextProvider } from "./State/CampaignReportContext";

export function FormProfile() {
  useClientChangeCallback("/leadcapture/forms");
  const navigate = useNavigate();
  const { displayError } = useNotification();
  const { id = "" } = useParams();
  const { clientId } = useAppSelector(selectClientValue);
  const state = useFormProfileState();
  const {
    getters: { campaign, dialogProps, error, isLoading, formData },
    handlers: { handleClearDialog },
  } = state;

  useEffect(() => {
    if (error) {
      displayError("Error fetching campaign details");
      navigate("/leadcapture/forms");
    }
    if (id !== "" && !isLoading && campaign?.clientId && campaign.clientId !== clientId) {
      navigate("/leadcapture/forms");
    }
  }, [navigate, campaign, clientId, isLoading, error, displayError, id]);

  if (isLoading || !campaign) {
    return <FormProfileLoading />;
  }

  return (
    <PageContainer>
      <Breadcrumb pageTitle={campaign.name} />
      <CampaignHeader state={state} />
      <CampaignProfileReportContextProvider campaignId={id} campaignContact={formData?.contactPreference}>
        <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 }, pt: { xs: 2, lg: 2 } }}>
          <FormTableTabs state={state} campaignId={id} formId={formData?.formId ?? ""} />
        </Paper>
      </CampaignProfileReportContextProvider>
      <RenderDialog open={dialogProps.open ?? false} handleClearDialog={handleClearDialog} {...dialogProps} />
    </PageContainer>
  );
}
